import { HTMLAttributes } from "react"

type FileProps = HTMLAttributes<SVGElement> & {
  size?: string
  color?: string
}

export const File = ({ size = "20", color = "#776E77", ...props }: FileProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5746 18.3332C4.34844 18.3332 3.3539 17.3179 3.35199 16.0642L3.3335 3.94262C3.33159 2.68613 4.32724 1.6665 5.5561 1.6665H10.7388C10.9351 1.6665 11.1233 1.7461 11.2622 1.88783L16.4493 7.18068C16.5886 7.32278 16.6668 7.5157 16.6668 7.71688V16.0606C16.6668 17.3157 15.6717 18.3332 14.4442 18.3332H5.5746ZM15.1844 8.03157L10.4324 3.18274V6.86878C10.4324 7.51097 10.9441 8.03157 11.5752 8.03157H15.1844ZM6.3841 14.651C6.3841 14.9721 6.63993 15.2324 6.95552 15.2324H13.0508C13.3663 15.2324 13.6222 14.9721 13.6222 14.651C13.6222 14.3299 13.3663 14.0696 13.0508 14.0696H6.95552C6.63993 14.0696 6.3841 14.3299 6.3841 14.651ZM6.95552 12.1316C6.63993 12.1316 6.3841 11.8713 6.3841 11.5502C6.3841 11.2291 6.63993 10.9688 6.95552 10.9688H10.0031C10.3187 10.9688 10.5746 11.2291 10.5746 11.5502C10.5746 11.8713 10.3187 12.1316 10.0031 12.1316H6.95552Z"
        fill={color}
      />
    </svg>
  )
}
